const SET_COMPACT_VIEW_TOGGLE  = '../actions';

const initialState = {
    compactView: false,
};

const CompactViewSettings = (state = initialState, action) => {
    switch (action.type) {
        // case SET_COMPACT_VIEW:
        //     return {
        //         ...state,
        //         compactView: action.payload,
        //     };
        case SET_COMPACT_VIEW_TOGGLE:
            return {
                ...state,
                compactView: action.payload,
            };
        default:
            return {
                ...state,
            };
    }
};

export default CompactViewSettings;                          